import React from 'react';

const Twitter: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none" {...props}>
    <path
      fill="#51A0EC"
      d="M41.786 17.224c.026.361.026.722.026 1.083C41.812 29.316 33.357 42 17.904 42 13.143 42 8.72 40.633 5 38.262c.676.077 1.327.103 2.03.103 3.927 0 7.544-1.315 10.431-3.558-3.694-.077-6.79-2.475-7.856-5.775.52.077 1.04.129 1.587.129.754 0 1.509-.103 2.211-.284-3.85-.773-6.738-4.125-6.738-8.172v-.103a8.521 8.521 0 003.798 1.057C8.2 20.163 6.717 17.61 6.717 14.723c0-1.546.416-2.964 1.145-4.202 4.136 5.053 10.354 8.353 17.326 8.714a9.315 9.315 0 01-.208-1.908C24.98 12.738 28.726 9 33.383 9a8.418 8.418 0 016.14 2.63 16.629 16.629 0 005.332-2.011 8.32 8.32 0 01-3.694 4.589c1.691-.18 3.33-.645 4.839-1.29a17.976 17.976 0 01-4.214 4.306z"
    ></path>
  </svg>
);

export default Twitter;
